(() => {
    "use strict";

    document.addEventListener('keydown', evt => {
        if (evt.key === 'Escape' || evt.key === 'Esc') {
            document.querySelectorAll('[data-element]').forEach(element => {
                element.classList.remove('is-active')
            })
            document.querySelectorAll('[data-toggle]').forEach(toggle => {
                toggle.classList.remove('is-active')
            })
        }
    })

    if (document.querySelector('[data-toggle]')) {
        const toggles = document.querySelectorAll('[data-toggle]')

        toggles.forEach(toggle => toggle.addEventListener('click', evt => {
            const element = document.querySelector(`[data-element="${evt.target.dataset.toggle}"]`)

            if (evt.target.dataset.toggle.includes('all')) {
                const target = evt.target.dataset.toggle.split('_')

                Array.from(document.querySelectorAll('[data-element]')).filter(el => {
                    if (el.dataset.element.startsWith(target[0])) {
                        el.classList.remove('default-is-active')
                        el.classList.toggle('is-active', !evt.target.classList.contains('is-active'))
                    }
                })
                
                Array.from(document.querySelectorAll('[data-toggle]')).filter(tgl => {
                    if (tgl.dataset.toggle.startsWith(target[0]) && !tgl.dataset.toggle.endsWith('all')) {
                        tgl.classList.remove('default-is-active')
                        tgl.classList.toggle('is-active', !evt.target.classList.contains('is-active'))
                    }
                })

                evt.target.classList.toggle('is-active')

            }

            if (!element) {
                return
            }

            handleVisibility(toggle, element)
        }))

        function handleVisibility(toggle, element) {

            if (toggle.classList.contains('default-is-active')) {
                toggle.classList.remove('default-is-active')
                toggle.classList.toggle('is-active', toggle.dataset.toggle.includes('all'))
            }
            else {
                toggle.classList.toggle('is-active')
            }

            if (element.classList.contains('is-expanded')) {
                element.classList.remove('is-expanded')
            }

            if (element.classList.contains('default-is-active')) {
                element.classList.remove('default-is-active')
                element.classList.toggle('is-active', toggle.dataset.toggle.includes('all'))
            }
            else {
                element.classList.toggle('is-active')
            }
        }
    }
    

    if (document.querySelectorAll('[data-accessibility-toggle]')) {
        const accessibilityToggles = document.querySelectorAll('[data-accessibility-toggle]')
        const body = document.getElementById('body')

        accessibilityToggles.forEach(toggle => {
            const options = toggle.querySelectorAll('span')
            let clicks = 0

            options.forEach((option, key) => {
                if (option.classList.contains('is-active')) {
                    clicks = key
                    return
                }
            })

            toggle.addEventListener('click', evt => {
                clicks++

                if (clicks == options.length) {
                    clicks = 0
                }

                options.forEach((option, key) => {
                    option.classList.remove('is-active')

                    if (key == clicks) {
                        option.classList.add('is-active')
                        toggle.title = option.dataset.optionTitle
                        body.dataset[`${toggle.dataset.accessibilityToggle}`] = option.dataset.optionValue
                    }
                })

                const resp = sendRequest({
                    capitalise: body.dataset.capitalise,
                    fontsize: body.dataset.fontsize,
                    showlinks: body.dataset.showlinks,
                    pauseanimations: body.dataset.pauseanimations,
                    hideimages: body.dataset.hideimages,
                    lineheight: body.dataset.lineheight,
                    colour: body.dataset.colour,
                })

                console.log(resp)
            })
        })
    }

    async function sendRequest(payload)
    {
        try {
            const resp = await fetch('/scripts/accessibility.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            })

            return await resp.json()
        }
        catch (err) {
            console.error(`Error fetching totals: ${err}`)
        }
    }

    if (document.querySelector('[data-aos]')) {
        AOS.init({
            offset: 0,
            duration: 1200,
            disable: 'mobile',
            once: true
        })
    }

    if (document.querySelector('[data-fancybox]')) {
        Fancybox.bind('[data-fancybox]', {

        })
    }

    if (document.querySelector('.nav__item.with-dropdown')) {
        let windowWidth = window.innerWidth

        window.addEventListener('resize', evt => {
            windowWidth = evt.target.innerWidth
        })

        if (windowWidth <= 1260) {
            document.querySelectorAll('.nav__item.with-dropdown button').forEach(item => {
                item.addEventListener('click', evt => {
                    evt.preventDefault()
                    evt.target.parentElement.parentElement.querySelector('.__nav__group').classList.toggle('is-active')
                })
            })
        }
    }
})()